import { create } from "zustand";

interface FilterEnquiriesState {
  govermentList: any[]; // you can replace `any` with your actual type
  governmentType: number | null;
  districtId: number | null;
  gender: number | null;
  ageFrom: number | null;
  ageTo: number | null;
  genderList: string[];
  openEnquiriesModal: boolean;
  startDate: string;
  endDate: string;
  schemeKeyword: string;
  states: any[];   // replace `any` with your model type if available
  category: any[];
  stateId: number | null;
  categoryId: number | null;
  applyFilter: boolean;
  searchValue:string;

  // actions
  setGovernmentList: (val: any[]) => void;
  setGovernmentType: (val: number | null) => void;
  setDistrictId: (val: number | null) => void;
  setGender: (val: number | null) => void;
  setAgeFrom: (val: number | null) => void;
  setAgeTo: (val: number | null) => void;
  setGenderList: (val: string[]) => void;
  setOpenEnquiriesModal: (val: boolean) => void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
  setSchemeKeyword: (val: string) => void;
  setStates: (val: any[]) => void;
  setCategory: (val: any[]) => void;
  setStateId: (val: number | null) => void;
  setCategoryId: (val: number | null) => void;
  setApplyFilter: (val: boolean) => void;
  setSearchValue:(val:string)=>void;
  resetFilter: () => void;
}

export const useFilterEnquiriesStore = create<FilterEnquiriesState>((set) => ({
  govermentList: [],
  governmentType: null,
  districtId: null,
  gender: null,
  ageFrom: null,
  ageTo: null,
  genderList: [],
  openEnquiriesModal: false,
  startDate: "",
  endDate: "",
  schemeKeyword: "",
  states: [],
  category: [],
  stateId: null,
  categoryId: null,
  applyFilter: true,
  searchValue:'',

  setGovernmentList: (val) => set({ govermentList: val }),
  setGovernmentType: (val) => set({ governmentType: val }),
  setDistrictId: (val) => set({ districtId: val }),
  setGender: (val) => set({ gender: val }),
  setAgeFrom: (val) => set({ ageFrom: val }),
  setAgeTo: (val) => set({ ageTo: val }),
  setGenderList: (val) => set({ genderList: val }),
  setOpenEnquiriesModal: (val) => set({ openEnquiriesModal: val }),
  setStartDate: (val) => set({ startDate: val }),
  setEndDate: (val) => set({ endDate: val }),
  setSchemeKeyword: (val) => set({ schemeKeyword: val }),
  setStates: (val) => set({ states: val }),
  setCategory: (val) => set({ category: val }),
  setStateId: (val) => set({ stateId: val }),
  setCategoryId: (val) => set({ categoryId: val }),
  setApplyFilter: (val) => set({ applyFilter: val }),
  setSearchValue:(val)=>set({searchValue:val}),

  resetFilter: () =>
    set({
      governmentType: null,
      districtId: null,
      gender: null,
      ageFrom: null,
      ageTo: null,
      startDate: "",
      endDate: "",
      schemeKeyword: "",
      stateId: null,
      categoryId: null,
      applyFilter: true,
    }),
}));

export const useActiveFilterCount = () => {
  const {
    startDate,
    endDate,
    schemeKeyword,
    stateId,
    categoryId,
    ageTo,
    gender,
    districtId,
    ageFrom,
    searchValue,
    governmentType,
  } = useFilterEnquiriesStore();

  let count = 0;
  if (startDate) count++;
  if (endDate) count++;
  if (schemeKeyword) count++;
  if (stateId !== null) count++;
  if (categoryId !== null) count++;
  if (ageTo !== null) count++;
  if (ageFrom !== null) count++;
  if (gender) count++;
  if (districtId !== null) count++;
  if (searchValue) count++;
  if (governmentType !== null) count++;

  return count;
};